import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useForm, Controller } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function AlertNotificationList() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const [userData, setUserData] = useState([]);
  const [selectedCenterIds, setSelectedCenterIds] = useState(
    savedCenterId || null
  );
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [attachmentFileName, setAttachmentFileName] = useState("");
  const userId = localStorage.getItem("userId");

  const {
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    setValue,
    trigger,
    register,
    getValues,
  } = useForm({
    defaultValues: {
      centerId: "",
      title: "",
      notificationMessage: "",
      datetime: "",
      AttachmentName: "",
    },
  });
  useEffect(() => {
    getAlertNotificationList();
  }, []);
  const getAlertNotificationList = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }
    try {
      const response = await get(
        `User/GetAlertNotifications?centerId=${savedCenterId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUserData(response);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const columns = [
    { name: "Sr No.", selector: (row, rowIndex) => rowIndex + 1 },
    {
      name: "notificationDate",
      selector: (row) => row.notificationDate,
      sortable: true,
      omit: true,
    },
    {
      name: "notificationSource",
      selector: (row) => row.notificationSource,
      sortable: true,
    },
    {
      name: "notificationTitle",
      selector: (row) => row.notificationTitle,
      sortable: true,
    },
    {
      name: "notificationMessage",
      selector: (row) => row.notificationMessage,
      sortable: true,
    },
  ];

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Notification List</h2>
      </div>
      <div className="col-md-12">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <label className="form-label">
                  Alert Notification<span className="text-danger fs-9">*</span>
                </label>
                <DataTable
                  columns={columns}
                  data={userData}
                  pagination
                  dense
                  customStyles={customTableStyles}
                  highlightOnHover={true}
                  pointerOnHover={true}
                  selectableRows
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AlertNotificationList;
